export default function getInitialState() {
  return {
    toast: null,
    messageBanner: null,
    isMobileChatOpen: false
  };
}
